import { render, staticRenderFns } from "./SubchannelChart.vue?vue&type=template&id=ae2e6986&"
import script from "./SubchannelChart.vue?vue&type=script&lang=js&"
export * from "./SubchannelChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports